// extracted by mini-css-extract-plugin
export default {"LinkItem":"MenuLink_LinkItem__z3FwN","LinkItem_text":"MenuLink_LinkItem_text__U3idJ","defaultBorder":"MenuLink_defaultBorder__BmZYT"};